// Vendor imports
const Immutable = require('immutable')
// Client V2 common imports
const { keyedReviver } = require('client-v2/common/state/record-reviver')
const EnvRecord = require('client-v2/common/state/env/record')
const RouterRecord = require('client-v2/common/state/router/record')
const UserRecord = require('client-v2/common/state/user/record')
// Entry imports
const BannerSectionRecord = require('client-v2/logged-out-landing-v2/containers/banner-section/record')
const HeroSectionRecord = require('client-v2/logged-out-landing-v2/containers/hero-section/record')

class LandingRootRecord extends Immutable.Record({
  // Common state
  env: null,
  router: null,
  user: null,
  // Entry state
  bannerSection: new BannerSectionRecord(),
  heroSection: new HeroSectionRecord()
}) {
  // No methods
}

LandingRootRecord.reviver = keyedReviver(LandingRootRecord, {
  // Common state
  env: EnvRecord.reviver,
  router: RouterRecord.reviver,
  user: UserRecord.reviver,
  // Entry state
  bannerSection: BannerSectionRecord.reviver,
  heroSection: HeroSectionRecord.reviver
})

module.exports = LandingRootRecord
